/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleSlotResponse
 */
export interface DutyScheduleSlotResponse {
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleSlotResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleSlotResponse
     */
    columnId: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleSlotResponse
     */
    counselorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleSlotResponse
     */
    counselorUserCode: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleSlotResponse
     */
    matchesPreference: boolean;
}

/**
 * Check if a given object implements the DutyScheduleSlotResponse interface.
 */
export function instanceOfDutyScheduleSlotResponse(value: object): value is DutyScheduleSlotResponse {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('columnId' in value) || value['columnId'] === undefined) return false;
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('counselorUserCode' in value) || value['counselorUserCode'] === undefined) return false;
    if (!('matchesPreference' in value) || value['matchesPreference'] === undefined) return false;
    return true;
}

export function DutyScheduleSlotResponseFromJSON(json: any): DutyScheduleSlotResponse {
    return DutyScheduleSlotResponseFromJSONTyped(json, false);
}

export function DutyScheduleSlotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleSlotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'columnId': json['columnId'],
        'counselorId': json['counselorId'],
        'counselorUserCode': json['counselorUserCode'],
        'matchesPreference': json['matchesPreference'],
    };
}

export function DutyScheduleSlotResponseToJSON(json: any): DutyScheduleSlotResponse {
    return DutyScheduleSlotResponseToJSONTyped(json, false);
}

export function DutyScheduleSlotResponseToJSONTyped(value?: DutyScheduleSlotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'columnId': value['columnId'],
        'counselorId': value['counselorId'],
        'counselorUserCode': value['counselorUserCode'],
        'matchesPreference': value['matchesPreference'],
    };
}

